import React from 'react';
import '../../App.scss';
import { updateState } from "../StateHelper";
import { Badge } from 'react-bootstrap';
import AuthorizedPage from '../../component/AuthorizedPage';
import OrderApi from '../../api/OrderApi';
import { Role } from '../../domain/Role';

const initialState = {
  orders: [] as any[]
};

class WareHouseOrderManagement extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    this.init();
  }

  init() {
    this.loadOrders();
  }

  async loadOrders() {
    // Sadece depo operasyonu bekleyenleri listele (Read-Only)
    let response = await OrderApi.filterByOperationTypeAndList("WAITING_FOR_WAREHOUSE_OPERATION");
    if (response.success) {
      updateState(this, "orders", response.data);
    }
  }

  renderOrders = () => {
    if (!this.state.orders || this.state.orders.length === 0) {
      return <div className="text-center mt-4"><h6>Görüntülenecek depo işlemi bulunamadı.</h6></div>;
    }

    return this.state.orders.map((item: any) => {
      let orderItems = this.renderOrderItems(item.orderItems);

      return (
        <div key={item.id} className="row basket-border" style={{ marginTop: "35px", paddingTop: "16px", paddingBottom: "10px" }}>
          <div className="row">
            <div className="col-md-8">
              <h4 className="text-primary">{item.buyer.title || ""} {item.buyer.name || ""} <small className="text-muted">#({item.buyer.code})</small></h4>
            </div>
            <div className="col-md-4 text-end">
               <h5><Badge bg="secondary">{item.orderNumber}</Badge></h5>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-md-4">
              <span style={{ display: "block" }}><strong>Sipariş Tarihi:</strong> {new Intl.DateTimeFormat('tr-TR').format(new Date(item.createdAt))}</span>
            </div>
            <div className="col-md-4">
              <span style={{ display: "block" }}>
                <strong>Planlanan Sevk:</strong> <Badge bg="danger">{new Intl.DateTimeFormat('tr-TR').format(new Date(item.plannedShipmentDate))}</Badge>
              </span>
            </div>
            <div className="col-md-4">
               {/* Buraya depo notu vs. eklenebilir */}
            </div>
          </div>

          <div className="mt-3">
            {orderItems}
          </div>
        </div>
      )
    });
  };

  renderOrderItems = (orderItems: any) => {
    return orderItems && orderItems.map((item: any) => {

      let itemContents = item.productContent && item.productContent.map((contenItem: any, idx: number) => {
        return <li key={idx}>{contenItem.quantity} Adet {contenItem.name} ({contenItem.barcode})</li>
      });

      return (
        <div key={item.id} className="row mb-3 p-2 border-top">
          {/* Ürün Bilgisi */}
          <div className="col-md-6">
            <h6 className="fw-bold">{item.productName}</h6>
            <span style={{ fontSize: "13px", color: "#666" }}>Stok Kodu: {item.stockCode} | Barkod: {item.barcode}</span>

            <div className="mt-2">
              {itemContents && <ul>{itemContents}</ul>}
            </div>
          </div>

          {/* Durum ve Araç Bilgisi */}
          <div className="col-md-3">
             <span style={{ display: "block", fontSize: "0.9rem" }}>Durumu: <Badge bg="info">{item.statusDescription.label}</Badge></span>
             <span style={{ display: "block", fontSize: "0.85rem", marginTop: "4px" }}>
               Planlanan Araç: <strong>{item.plannedShipmentVehicleDescription || "-"}</strong>
             </span>
          </div>

          {/* Miktar Bilgileri */}
          <div className="col-md-3 text-end">
             <div style={{ fontSize: "0.9rem" }}>Sipariş Miktarı: <strong>{item.quantity}</strong></div>
             <div style={{ fontSize: "0.9rem" }}>Koli Adedi: <strong>{item.boxQuantity}</strong></div>

             {/* Yükleme durumu progress mantığında gösterilebilir */}
             <div className="mt-2" style={{ fontSize: "0.85rem", color: "#555" }}>
                Yüklenen: <span className="text-success fw-bold">{item.loadedQuantity || 0}</span> /
                Kalan: <span className="text-danger fw-bold">{item.remainingQuantity || item.quantity}</span>
             </div>
          </div>
        </div>
      )
    });
  }

  render() {
    const orders = this.renderOrders();
    return (
      <AuthorizedPage role={Role.WAREHOUSE_STAFF}>
        <div className="centered-95-percent">
          <h3 className="mb-4">Depo İşlemleri (İzleme)</h3>
          {orders}
        </div>
      </AuthorizedPage>
    )
  }
}

export default WareHouseOrderManagement;